import { Store as elfStore } from "@ngneat/elf";
import { defer, MonoTypeOperatorFunction, Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { resetError, resetLoading, setLoading } from "./stateprops";


export const initializeRequestElf = <T>(store: elfStore): MonoTypeOperatorFunction<T> => {
    return (source: Observable<T>) => {
        return defer(() => {
            store.update(setLoading(true));
            store.update(resetError());
            return source.pipe(finalize(() => store.update(resetLoading())));
        });
    };
};